import React from 'react'
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles'
import * as styles from './_AdviserProfileEducationEditor.scss'
import { Form, FormCheck, Row, Col } from 'react-bootstrap'
import FieldGroup from '../../../common/forms/FieldGroup'
import EditButton from '../../../common/forms/EditButton'
import YearMonthPicker from '../../../common/forms/YearMonthPicker'

let descriptionTouched = false

const handleDescriptionFocus = (event) => {
  descriptionTouched = true
}

const handleDescriptionBlur = (event) => {
  let value = event.target.value
  getDescriptionvalidationstate(descriptionTouched, value)
}

const getDescriptionvalidationstate = (touched, value) => {
  if (!touched) {
    return {
      isInvalid: false,
      message: null,
      valid: false
    }
  }

  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter a description',
      valid: false
    }
  }

  if (value.length === 0) {
    return {
      isInvalid: true,
      message: 'Please enter a description',
      valid: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true
  }
}

const handleDescriptionChange = (handleChange, event, validationstate) => {
  let value = event.target.value
  let validationResult = getDescriptionvalidationstate(descriptionTouched, value)
  handleChange({
    description: validationResult,
    institution: validationstate.institution
  }, value)
}

let institutionTouched = false

const handleInstitutionFocus = (event) => {
  institutionTouched = true
}

const handleInstitutionBlur = (event) => {
  let value = event.target.value
  getDescriptionvalidationstate(institutionTouched, value)
}

const getInstitutionvalidationstate = (touched, value) => {
  if (!touched) {
    return {
      isInvalid: false,
      message: null,
      valid: false
    }
  }

  if (!value) {
    return {
      isInvalid: true,
      message: 'Please enter a institution',
      valid: false
    }
  }

  if (value.length === 0) {
    return {
      isInvalid: true,
      message: 'Please enter a institution',
      valid: false
    }
  }

  return {
    isInvalid: false,
    message: null,
    valid: true
  }
}

const handleInstitutionChange = (handleChange, event, validationstate) => {
  let value = event.target.value
  let validationResult = getInstitutionvalidationstate(institutionTouched, value)
  handleChange({
    institution: validationResult,
    description: validationstate.description
  }, value)
}

const validateStartEndYear = (handleStartYear, handleEndYear, startYear, endYear, startYearValidationResult, endYearValidationResult, validateMonths) => {
  const successfullResult = {
    isInvalid: false,
    message: null,
    valid: true
  }

  const startYearResult = {
    isInvalid: true,
    message: 'Start year cannot be greater than end year',
    valid: false
  }

  const endYearResult = {
    isInvalid: true,
    message: 'End year cannot be less than start year',
    valid: false
  }

  const startIndependentlyInvalid = !startYearValidationResult.valid && startYearValidationResult.message !== startYearResult.message
  const endIndependentlyInvalid = !endYearValidationResult.valid && endYearValidationResult.message !== endYearResult.message

  // If either year has its own (non-cross-field) validation error, keep both results and skip
  // the start>end comparison - but still COMMIT both, so the field the user just corrected is
  // not discarded (which previously wedged Save when both years were invalid at once).
  if (startIndependentlyInvalid || endIndependentlyInvalid) {
    handleStartYear(startYearValidationResult, startYear)
    handleEndYear(endYearValidationResult, endYear)
    validateMonths(startYear, endYear)
    return
  }

  if (endYear !== null) {
    if (endYear < startYear) {
      startYearValidationResult = startYearResult
      endYearValidationResult = endYearResult
    } else {
      startYearValidationResult = successfullResult
      endYearValidationResult = successfullResult
    }
  }

  handleStartYear(startYearValidationResult, startYear)
  handleEndYear(endYearValidationResult, endYear)
  validateMonths(startYear, endYear)
}

const validateStartEndMonth = (handleStartMonth, handleEndMonth, startMonth, endMonth, startYear, endYear, startMonthValidationResult, endMonthValidtionResult) => {
  const successfullResult = {
    isInvalid: false,
    message: null,
    valid: true
  }

  const startMonthResult = {
    isInvalid: true,
    message: 'Start month cannot be greater than end month',
    valid: false
  }

  const endMonthResult = {
    isInvalid: true,
    message: 'End month cannot be less than start month',
    valid: false
  }

  if (endYear !== null) {
    if (endYear === startYear) {
      if (endMonth < startMonth) {
        startMonthValidationResult = startMonthResult
        endMonthValidtionResult = endMonthResult
      } else {
        startMonthValidationResult = successfullResult
        endMonthValidtionResult = successfullResult
      }
    } else {
      startMonthValidationResult = successfullResult
      endMonthValidtionResult = successfullResult
    }
  }

  handleStartMonth(startMonthValidationResult, startMonth)
  handleEndMonth(endMonthValidtionResult, endMonth)
}

const AdviserQualificationEditor = ({
    formIsValid,
    qualification,
    editingQualification,
    dateHandleChange,
    studyStartMonth,
    studyStartYear,
    studyEndMonth,
    studyEndYear,
    validationstate,
    stopEditingQualification,
    cancelEditingQualification,
    descriptionHandleChange,
    institutionHandleChange,
    handleStudyStartMonth,
    handleStudyStartYear,
    handleStudyEndMonth,
    handleStudyEndYear,
    handleCurrentEndYear,
    children
  }) => {
  return <div className={styles['form-bottom-margin']}>
    <Form.Group>
      <FieldGroup
        required
        value={qualification.description !== null ? qualification.description : ''}
        onChange={(event) => {
          handleDescriptionChange(descriptionHandleChange, event, validationstate)
        }}
        label='Education Description'
        isInvalid={validationstate.description.isInvalid}
        message={validationstate.description.message}
        onBlur={handleDescriptionBlur}
        onFocus={handleDescriptionFocus}
        />
      <FieldGroup
        required
        value={qualification.institution !== null ? qualification.institution : ''}
        onChange={(event) => {
          handleInstitutionChange(institutionHandleChange, event, validationstate)
        }}
        label='Education Institution'
        message={validationstate.institution.message}
        isInvalid={validationstate.institution.isInvalid}
        onBlur={handleInstitutionBlur}
        onFocus={handleInstitutionFocus}
        />
      <Form.Group>
        <Row>
          <Col className="d-none d-sm-block" sm={6} md={6} lg={6}>
            <YearMonthPicker
              label={'Start'}
              month={studyStartMonth !== null ? studyStartMonth : 0}
              year={parseInt(studyStartYear)}
              handleMonth={(value) => {
                validateStartEndMonth(handleStudyStartMonth, handleStudyEndMonth, value, studyEndMonth, studyStartYear, studyEndYear, validationstate.startMonth, validationstate.endMonth)
              }}
              handleYear={(validationResult, value) => {
                validateStartEndYear(handleStudyStartYear, handleStudyEndYear, value, studyEndYear, validationResult, validationstate.endYear, (startYear, endYear) => {
                  validateStartEndMonth(handleStudyStartMonth, handleStudyEndMonth, studyStartMonth, studyEndMonth, startYear, endYear, validationstate.startMonth, validationstate.endMonth)
                })
              }}
              handleChange={dateHandleChange}
              yearisInvalid={validationstate.startYear}
              monthisInvalid={validationstate.startMonth}
              />
          </Col>
          <Col className="d-none d-sm-block" sm={6} md={6} lg={6}>
            {qualification.studyEndDate !== null ? <YearMonthPicker
              label={'End'}
              disabled={qualification.studyEndDate === null}
              month={studyEndMonth !== null ? studyEndMonth : 11}
              year={parseInt(studyEndYear)}
              handleMonth={(value) => {
                validateStartEndMonth(handleStudyStartMonth, handleStudyEndMonth, studyStartMonth, value, studyStartYear, studyEndYear, validationstate.startMonth, validationstate.endMonth)
              }}
              handleYear={(validationResult, value) => {
                validateStartEndYear(handleStudyStartYear, handleStudyEndYear, studyStartYear, value, validationstate.startYear, validationResult, (startYear, endYear) => {
                  validateStartEndMonth(handleStudyStartMonth, handleStudyEndMonth, studyStartMonth, studyEndMonth, startYear, endYear, validationstate.startMonth, validationstate.endMonth)
                })
              }}
              handleChange={dateHandleChange}
              yearisInvalid={validationstate.endYear}
              monthisInvalid={validationstate.endMonth}
              /> : ''}
          </Col>
        </Row>
        <FormCheck
          type="checkbox"
          checked={qualification.studyEndDate === null}
          value={(studyEndYear == null || isNaN(studyEndYear)) ? '' : studyEndYear}
          onChange={() => {
            handleCurrentEndYear()
          }}
          label="Currently Studying"
        />

      </Form.Group>
      <EditButton
        formIsValid={formIsValid}
        editing={editingQualification}
        cancelEditing={() => {
          cancelEditingQualification()
        }}
        stopEditing={() => {
          stopEditingQualification()
        }}
        />
    </Form.Group>
  </div>
}

AdviserQualificationEditor.propTypes = {
  formIsValid: PropTypes.bool.isRequired,
  qualification: PropTypes.object.isRequired,
  editingQualification: PropTypes.bool.isRequired,
  studyStartMonth: PropTypes.number,
  studyStartYear: PropTypes.number,
  studyEndMonth: PropTypes.number,
  studyEndYear: PropTypes.number,
  validationstate: PropTypes.object.isRequired,
  stopEditingQualification: PropTypes.func.isRequired,
  cancelEditingQualification: PropTypes.func.isRequired,
  descriptionHandleChange: PropTypes.func.isRequired,
  institutionHandleChange: PropTypes.func.isRequired,
  dateHandleChange: PropTypes.func.isRequired,
  handleStudyStartMonth: PropTypes.func.isRequired,
  handleStudyStartYear: PropTypes.func.isRequired,
  handleStudyEndMonth: PropTypes.func.isRequired,
  handleStudyEndYear: PropTypes.func.isRequired,
  handleCurrentEndYear: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.node, 
    PropTypes.arrayOf(PropTypes.node)
  ])
}

export default ( (AdviserQualificationEditor))
